/**
 * Aba Apetite proativo em leitura (PR2).
 *
 * Renderiza `proactiveAppetite` REAL (none | conservative | balanced | active)
 * destacado entre os 4 níveis do backend. O protótipo usava R2/R3/R4 +
 * tipos de oportunidade/carência — sem fonte no serializer, logo omitidos
 * (zero dado falso). Edição chega no PR4.
 */

import { APPETITE_LABELS } from '../playbook-labels';

import type { PlaybookDto, PlaybookProactiveAppetite } from '../types';

const APPETITE_ORDER: PlaybookProactiveAppetite[] = ['none', 'conservative', 'balanced', 'active'];

export function TabAppetite({ playbook }: { playbook: PlaybookDto }): JSX.Element {
  const current = playbook.proactiveAppetite;

  return (
    <div className="pb-panel" role="tabpanel" aria-label="Apetite">
      <h2 className="pb-panel__title">Apetite proativo</h2>

      <div className="pb-panel__section">
        <span className="pb-panel__section-label">Nível de proatividade deste playbook</span>
        <div className="pb-radio-row">
          {APPETITE_ORDER.map((level) => {
            const meta = APPETITE_LABELS[level];
            const selected = level === current;
            return (
              <div
                key={level}
                className={'pb-radio' + (selected ? ' pb-radio--selected' : '')}
                aria-current={selected ? 'true' : undefined}
              >
                <span className="pb-radio__dot" />
                <span className="pb-radio__main">
                  <span className="pb-radio__label">{meta.label}</span>
                  <span className="pb-radio__desc">{meta.desc}</span>
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
